export function clearDateTime() {
  $(".schedule-email").find(":input").val("");
  $(".survey_error").remove();
}
